<template>
  <shared-step-editor-file-drop :accept="accept" :disabled="uploading" @drop="onSelectFile">
    <shared-step-editor-file-picker v-slot="{open}" :accept="accept" @select-file="onSelectFile">
      <button :disabled="uploading" class="social-step-editor-sidebar-media-drop__button" @click="open">
        <img :src="`/wp-content/themes/snappy-theme/assets/images/builders/upload.svg`" alt="Upload" />
        <span>Click here to select an image to upload, drag and drop an image here, or enter the URL of an image below.</span>
        <br>
        <span><small>Images must be smaller than 2,000 by 2,000 pixels and they must be less than two megabytes.</small></span>
      </button>
    </shared-step-editor-file-picker>
  </shared-step-editor-file-drop>
</template>

<script>
import SharedStepEditorFileDrop from '../../shared/file/SharedStepEditorFileDrop.vue';
import SharedStepEditorFilePicker from '../../shared/file/SharedStepEditorFilePicker.vue';

export default {
  components: {
    SharedStepEditorFileDrop,
    SharedStepEditorFilePicker,
  },
  props: {
    accept: String,
    uploading: Boolean,
  },
  methods: {
    onSelectFile(file) {
      this.$emit('select', file);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../../../sass/web/_variables.scss';

.social-step-editor-sidebar-media-drop {
  &__button {
    border: 1px dashed $color-regent-grey;
    color: $color-regent-grey;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
    background: transparent;
    cursor: pointer;
  }
}
</style>
